import Seo, { SITE_NAME, SITE_URL } from "@/components/base/Seo";
import SiteLayout from "@/components/feature/SiteLayout";
import HeroSection from "@/pages/home/components/HeroSection";
import CategorySection from "@/pages/home/components/CategorySection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import TagFaqSection from "@/pages/home/components/TagFaqSection";
import BrandBand from "@/pages/home/components/BrandBand";
import {
  articles,
  getArticleById,
  hotArticles,
  latestArticles,
  type Article,
} from "@/mocks/articles";

const pick = (ids: string[]): Article[] =>
  ids.map(getArticleById).filter((item): item is Article => Boolean(item));

export default function Home() {
  const featured = getArticleById("variety-highlights-2026") ?? articles[0];
  const hot = hotArticles(5);
  const timeline = latestArticles(5);
  const editorPicks = pick(["casting-topic-balance", "creator-boom-cooling", "red-carpet-style-review"]);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE_NAME,
      url: SITE_URL,
      inLanguage: "zh-CN",
      description:
        "看料88是专注娱乐话题回顾的资讯存档站，整理往期热料、旧料回顾与经典话题盘点，按时间线与分类归档历史内容。",
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_URL}/archive?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
      email: "hello@kanliao88.example.com",
      description: "看料88，娱乐话题回顾与往期存档站。",
    },
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "看料88 往期热料存档",
      url: SITE_URL,
      inLanguage: "zh-CN",
      mainEntity: {
        "@type": "ItemList",
        itemListElement: articles.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.title,
          url: `${SITE_URL}/article/${item.id}`,
        })),
      },
    },
  ];

  return (
    <SiteLayout>
      <Seo
        title="看料88 | 往期娱乐热料存档 · 历史话题与旧料回顾合集"
        description="看料88专注娱乐话题回顾，按时间线整理往期热料、旧料与经典话题盘点，涵盖综艺、影视、创作者与网络热议，想回看往期爆料的话题走向，从这里开始。"
        keywords="看料88,往期热料,娱乐话题存档,旧料回顾,综艺盘点,影视观察"
        path="/"
        jsonLd={jsonLd}
      />
      <HeroSection featured={featured} hot={hot} />
      <CategorySection />
      <TimelineSection items={timeline} />
      <FeaturedSection items={editorPicks} />
      <TagFaqSection />
      <BrandBand />
    </SiteLayout>
  );
}